import { Flex, Text } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks";
import { useTranslate } from "src/i18n";

import { TextSection } from "../TextSection";
import { SolutionCard } from "./components/SolutionCard";
import { CARDS } from "./SolutionBlock.constants";

export const SolutionBlock = () => {
  const { isMobile } = useGravityDevice();

  const { t } = useTranslate();

  return (
    <Flex
      id="solution"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection
        title={t("landing.solution.title", "Ваши результаты с нами!")}
        description={t(
          "landing.solution.description",
          "Возможности, которые получают клиенты использующие наш продукт",
        )}
      />
      <Flex
        wrap={isMobile ? undefined : "wrap"}
        direction={isMobile ? "column" : "row"}
        justifyContent={isMobile ? "center" : "space-between"}
        gap={4}
      >
        {CARDS.map((card) => (
          <SolutionCard
            key={`card.${card.title}`}
            title={card.title}
            summary={card.summary}
            icon={card.icon}
          >
            {card.elements.map((el) => (
              <Text key={el} variant="body-1" color="complementary">
                {el}
              </Text>
            ))}
          </SolutionCard>
        ))}
      </Flex>
    </Flex>
  );
};
